import { render, staticRenderFns } from "./SpOrdersLocation4CreateEdit.vue?vue&type=template&id=396f08a7&scoped=true&"
import script from "./SpOrdersLocation4CreateEdit.vue?vue&type=script&lang=js&"
export * from "./SpOrdersLocation4CreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./SpOrdersLocation4CreateEdit.vue?vue&type=style&index=0&id=396f08a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396f08a7",
  null
  
)

export default component.exports